<template>
  <div class="model-warp" v-show="isShowModel">
    <div class="modal">

      <div class="title">
        <h3>患者登记</h3>
        <span @click="cancel">×</span>
      </div>

      <div class="content">
        <div class="form-item">
          <label><span class="label"><span class="red">*</span>姓名：</span><input type="text" id="name"
                                                                                v-model="info.name"
                                                                                placeholder="请输入患者本人姓名"></label>

        </div>
        <div class="form-item">
          <label><span class="label"><span class="red">*</span>手机号：</span><input type="text" id="number"
                                                                                 v-model.number="info.telephone"
                                                                                 placeholder="请输入联系人手机号"></label>
        </div>

        <div class="form-item">
          <p class="label"><span class="red">*</span>您与患者的关系：</p>
          <ul>
            <li v-for="item in relation" @click="selectRelation(item.id)"><span
                    :class="item.isActive ? 'active':''"></span>{{item.value}}
            </li>
          </ul>
        </div>

        <div class="form-item">
          <p class="agree-warp"><input type="checkbox" v-model="info.isRead" :value="false">我已阅读并同意<span @click="toUserProtocol">《用户使用协议》</span></p>
        </div>

        <div class="submit-warp">
          <button class="link-button submit-button" @click="submit">提交</button>
          <button class="link-button cancel-button" @click="cancel">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {register} from '../services/http'
  import store from "../store";
  export default {
    name: "RegisterForm",
    props: {
      isShowModel: {
        default: false,
      }
    },
    data() {
      return {
        relation: [
          {isActive: false, value: '本人', id: 1},
          {isActive: false, value: '家属', id: 2},
          {isActive: false, value: '朋友', id: 3},
          {isActive: false, value: '其他', id: 5},
        ],
        info: {
          name: '',
          telephone: null,
          relation: '',
          isRead: false,
        }
      }
    },
    computed: {
      userInfo() {
        return store.getters.userInfo;
      }
    },
    methods: {
      selectRelation(value) {
        this.info.relation = value;
        this.relation.forEach(item => {
          item.isActive = item.id === value ? true : false;
        })
      },

      submit() {
        let {name, telephone, isRead, relation} = this.info;
        if (!name) {
          alert('请填写姓名');
          return
        }
        if (!telephone || !(/^1\d{10}/.test(telephone+''))) {
          alert('请填写正确的手机号');
          return
        }
        if (!relation) {
          alert('请选择患者关系');
          return
        }
        if (!isRead) {
          alert('请阅读并同意《用户使用协议》');
          return
        }

        this.register(this.info);
      },

      cancel() {
        this.$emit('showModel', false)
      },
      register(json) {
        register(json).then(res => {
          let info = Object.assign({},this.userInfo,{is_need_register:false});
          store.commit('setUserInfo',info);
          this.cancel();
        })
      },

      toUserProtocol(){
        this.$router.push({path:`/userProtocol`})
      }
    }
  }
</script>

<style scoped lang="less">
  .model-warp {
    position: fixed;
    z-index: 888;
    overflow: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(55, 55, 55, .6);
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .modal {
      width: 640px;
      background-color: #fff;
      .title {
        height: 42px;
        line-height: 42px;
        display: flex;
        justify-content: space-between;
        color: #fff;
        background-color: #34404D;
        h3 {
          font-size: 16px;
          margin-left: 24px;
        }
        span {
          margin-right: 16px;
          cursor: pointer;
        }
      }

      .content {
        padding: 40px 0;
        font-size: 14px;
        color: rgba(0, 0, 0, .85);
        .form-item {
          margin-bottom: 16px;
          display: flex;
          .red {
            color: red;
            margin-right: 8px;
          }
          label {
            display: flex;
            align-items: center;
          }
          .label {
            width: 196px;
            text-align: right;

          }
          input {
            margin-left: 10px;
            width: 256px;
            height: 32px;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.85);
            border: 1px solid rgba(0, 0, 0, 0.15);
            padding-left: 12px;
            outline: none;
          }

          ul {
            display: flex;
            margin-left: 8px;
            li {
              display: flex;
              align-items: center;
              margin-right: 32px;
              span {
                width: 14px;
                height: 14px;
                border: 1px solid rgba(0, 0, 0, 0.15);
                border-radius: 50%;
                margin-right: 8px;
                color: rgba(0, 0, 0, 0.85);
              }
              .active {
                border-color: #108EE9;
              }
            }

          }

          .agree-warp {
            margin-left: 204px;
            margin-top: 26px;
            display: flex;
            align-items: center;
            input{
              width: 14px;
              height: 14px;
              margin-right: 8px;
              margin-left: 0;
              border: 1px solid rgba(0,0,0,0.15);
              outline: none;
            }
            i {
              width: 14px;
              height: 14px;
              border: 1px solid rgba(0, 0, 0, 0.15);
              border-radius: 2px;
              margin-right: 8px;
              color: #fff;
              font-size: 10px;
              text-align: center;
              font-style: normal;
            }
            .read {
              color: #108EE9;
            }
            span {
              color: #108EE9;
              &:hover {
                cursor: pointer;
              }
            }
          }
        }
        .submit-warp {
          margin-left: 204px;
          display: flex;
          align-items: center;
          margin-top: 32px;
          button {
            margin-right: 16px;
            &:hover {
              cursor: pointer;
            }
          }
          .cancel {
            border: 1px solid #dedede;
            background: #fff;
            color: rgba(0, 0, 0, 0.65);
            margin-left: 16px;
          }
        }
      }
    }
  }
</style>